import { Link, useNavigate } from "react-router-dom";

import { Button, Card } from "../ui";
import { homePath } from "./access";
import { useCurrentMe } from "./auth";
import { type Screen } from "./screens";
import { useDocumentTitle } from "./title";

/** The page shown for a screen that its module has not built yet. */
export function Placeholder({ screen }: { screen: Screen }) {
  return (
    <Card className="placeholder" aria-labelledby="screen-title">
      <h1 id="screen-title">{screen.title}</h1>
      <p>{screen.summary}</p>
      <p className="muted">This screen is not available yet.</p>
    </Card>
  );
}

/** There is no screen at the address: say so, name the tab, and give two ways out (UI-26). */
export function NotFound() {
  const me = useCurrentMe();
  const navigate = useNavigate();
  useDocumentTitle("Page not found");
  return (
    <Card aria-labelledby="not-found-title">
      <h1 id="not-found-title">Page not found</h1>
      <p>There is no screen at this address.</p>
      <div className="row">
        <Link className="button button--primary" to={homePath(me)}>
          Go to the home screen
        </Link>
        <Button onClick={() => void navigate(-1)}>Go back</Button>
      </div>
    </Card>
  );
}
